import * as Common from '@/agiles/common';


export class Topics extends Common.StateObject{
    constructor(){
        super('Topics');        
        this.workflowCode="approval";
        this.workflowStateId = 1;//フラグ値を変更;        
    }    
  public get actionTooltip() {
    if (this.state == Common.ApprovalStatus.NotApproved)　return 'お知らせ画面に表示させる場合は【公開】をクリックします。';
    else if (this.state == Common.ApprovalStatus.Approved) return '内容を修正する場合は【公開取消】をクリックします。';     
    else return '';
  }      
    public id: number =0;
    public isAdmin :boolean = false;
    public from: string = '';
    public to:string = '';
    public title:string = '';
    public content:string = '';
    public showTargetFlag:ShowTargetFlags = ShowTargetFlags.None;

    public copy():any {
      const temp = super.copy() as Topics;
      temp.id = 0;
      temp.showTargetFlag = ShowTargetFlags.None;
      return temp;
    }
    public get messageOnDelete():string {
        return 'ワークフローが進行しているため削除できません。\r\nワークフローのボタンを操作し、状態を「公開待ち」に戻してから削除してください。';
    }
}
export enum ApprovalStatus
{
      NotApproved = 1,
      Approved = 2,
      All = NotApproved | Approved
}
export enum ShowTargetFlags
{
      None = 0,
      Stardard = 1,
      PrimeTrial = 2,
      PrimePaid = 4,
}
export class TopicsQuery extends Common.LoadQuery {
  constructor() {
    super('TopicsQuery', Topics);
    this.sort = 'lastUpdatedOn';
    this.isDescending=true;
    //初期値をセットする必要がある
    var now = new Date();
    this.timestampFrom = new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0,0,0);
    this.timestampTo = new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0,0,0);    
    //90日前を設定する
    this.timestampFrom.setDate(this.timestampFrom.getDate() - 90); 
  }
  public timestampFrom: Date;
  public timestampTo: Date;          
  public state: number = null;
  public isEditMode: boolean = false;  
  public id:number = null;
  public isAdmin:boolean = false;
}

export class TopicsSendQuery extends Common.Query {
    constructor(item: Common.Topics,targetFlag: Common.CampaignTenantFlags){
        super('TopicsSendQuery', null); //戻り値はint
        this.item = item;
        this.targetFlag = targetFlag;        
    }
    public isAsync:boolean = true;
    public item: Common.Topics;
    public targetFlag: Common.CampaignTenantFlags;
}